import { render, staticRenderFns } from "./SmsTemplateSelectorModal.vue?vue&type=template&id=1983adb4&"
import script from "./SmsTemplateSelectorModal.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports